module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_15_2.5f3c66b4.jpeg";